/**
 * Cum se desenează fișa dentară.
 *
 * Două reprezentări, nu două teme: culorile semnelor sunt aceleași în amândouă
 * — roșu pentru ce e de tratat, albastru pentru ce e făcut, chihlimbar pentru
 * ce se urmărește. Ce se schimbă e **obiectul desenat**, adică ce poate fi
 * arătat despre un dinte.
 *
 * `vestibular` e dintele văzut din față, cu coroană și rădăcină: singura vedere
 * în care se văd apexul, punga parodontală și lungimea rădăcinii. `dubla` pune
 * deasupra lui și fața ocluzală, unde o carie stă pe o suprafață anume — și
 * unde mezialul, distalul, vestibularul și oralul sunt patru locuri distincte,
 * nu trei fâșii pe același contur.
 *
 * Se păstrează și se aplică exact ca `appearance` și `calStyle`: pe elementul
 * rădăcină, oglindit în `localStorage` ca `index.html` să-l poată ștampila
 * înainte de prima desenare, și ținut pe clinică în `orgConfig`, fiindcă e
 * alegerea cabinetului, nu a unei persoane.
 */
// label/desc are `common` translation keys, resolved with t() at the render site.
export const CHART_STYLES = [
  {
    key: '',
    label: 'chartVestibular',
    desc: 'chartVestibularDesc',
  },
  {
    key: 'dubla',
    label: 'chartVedereDubla',
    desc: 'chartVedereDublaDesc',
  },
] as const;

export type ChartStyleKey = (typeof CHART_STYLES)[number]['key'];

const STORAGE_KEY = 'df.chartStyle';

const isKnown = (v: string): v is ChartStyleKey => CHART_STYLES.some((s) => s.key === v);

/** Ce stil e activ acum, citit de unde l-a lăsat ultima aplicare. */
export function currentChartStyle(): ChartStyleKey {
  if (typeof document === 'undefined') return '';
  const v = document.documentElement.dataset.chartStyle ?? '';
  return isKnown(v) ? v : '';
}

export function applyChartStyle(value: string) {
  const v = isKnown(value) ? value : '';
  const root = document.documentElement;
  if (v) root.dataset.chartStyle = v;
  else delete root.dataset.chartStyle;
  try {
    if (v) localStorage.setItem(STORAGE_KEY, v);
    else localStorage.removeItem(STORAGE_KEY);
  } catch {
    // Fereastră privată: se aplică acum și dispare la următoarea încărcare,
    // ceea ce e mai bine decât să nu se aplice deloc.
  }
  // Fișa e desenată de o componentă React care nu se uită la `dataset`. Fără
  // semnalul ăsta, alegerea din Setări s-ar vedea abia după o reîncărcare.
  window.dispatchEvent(new CustomEvent('df:chartstyle', { detail: v }));
}
